module.exports = __webpack_public_path__ + "img/passwordWeavr.8ca4f0bd.svg";